import React, { useCallback } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import FormHelperText from "@mui/material/FormHelperText";
export const SelectMember = (props) => {
    var _a;
    const updateSelectedMember = useCallback((e) => {
        console.log(e);
        props.updateSelectedMember("memberName", e.target.value);
    }, [props.updateSelectedMember]);
    return (React.createElement(FormControl, { fullWidth: true, disabled: props.disabled, variant: "filled" },
        React.createElement(InputLabel, { htmlFor: "select-reimbursement-member" }, "Select Member *"),
        React.createElement(Select, { label: "Select Member *", labelId: "select-reimbursement-member", id: "select-reimbursement-member", onChange: updateSelectedMember, value: props.value }, (_a = props === null || props === void 0 ? void 0 : props.list) === null || _a === void 0 ? void 0 : _a.map((data) => (React.createElement(MenuItem, { value: data }, data)))),
        React.createElement(FormHelperText, null, "Coverage required")));
};
